import { laceDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/front/lace'
import { laceOfBackOfArroundWebDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/front/lace/arroundWeb'
import { laceOfKnots } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/front/lace/knots'
import { littleMachi } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/front/littleMachi'
import { stitch } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/front/stitch'
import { thumbMachi } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/front/thumbMachi'
import { State } from 'src/types'
import { atomsEngravedOfCatchFaceOfJaModel } from 'src/features/atoms/glove/drawer/labels/atoms'
import { catchFaceDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/front/catchFace'
import { canvasResetter } from 'src/util/canvas'
import { webDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/front/web'
import { edgeDrawer } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/front/edge'
import { startInversion, undoInversion } from 'src/util/canvas'

export const atomsCanvasCatcherMittFrontLeftThrow = async (ctx: CanvasRenderingContext2D, state: State, canvasWidth: number): Promise<void> => {
  // リセット
  canvasResetter(ctx)

  startInversion(ctx, canvasWidth)
  laceOfKnots(ctx, state.lace.color, 0, 0)
  laceOfBackOfArroundWebDrawer(ctx, state)
  await webDrawer(ctx, state)
  catchFaceDrawer(ctx, state)

  thumbMachi(ctx, state.catchFaceTarget.color)
  littleMachi(ctx, state.catchFaceTarget.color)

  edgeDrawer(ctx, state)
  stitch(ctx, state.stitch.color)
  laceDrawer(ctx, state)

  undoInversion(ctx, canvasWidth)
  // メーカーの刻印
  atomsEngravedOfCatchFaceOfJaModel(ctx, -80, -20, state.catchFace?.color)
}
